export default "__VITE_ASSET__CoungbBI__"